import { render, staticRenderFns } from "./schedaPolizza.vue?vue&type=template&id=68e8b86b&"
import script from "./schedaPolizza.vue.ts?vue&type=script&lang=ts&"
export * from "./schedaPolizza.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports